import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=90b5bea0&scoped=true&"
import script from "./TheModal.vue?vue&type=script&lang=ts&"
export * from "./TheModal.vue?vue&type=script&lang=ts&"
import style0 from "./TheModal.vue?vue&type=style&index=0&id=90b5bea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b5bea0",
  null
  
)

export default component.exports